import { useState, useEffect } from 'react';
import { useParams, Link } from 'react-router-dom';
import SEO from '../components/SEO';
import Lightbox from '../components/Lightbox';
import { imageUrl } from '../lib/images';

const ydelserData = {
  'nyt-tag': {
    title: 'Nyt tag & Tagrenovering',
    metaTitle: 'Nyt tag & Tagrenovering i Egtved',
    metaDesc: 'Få lagt nyt tag eller udført professionel tagrenovering af Tømrermester Mikkel Juler ApS i Egtved, Kolding og Vejle. Vi rådgiver om materialer og sikrer holdbare løsninger.',
    h1: 'Nyt tag & tagrenovering i Egtved, Kolding & Vejle',
    intro: 'Et sundt og tæt tag er afgørende for at beskytte din bolig mod det danske vejr. Tømrermester Mikkel Juler ApS tilbyder professionel tagudskiftning og tagrenovering med fokus på holdbare løsninger, grundig rådgivning og det rette materialevalg.',
    sections: [
      {
        title: 'Tagudskiftning – En investering i fremtiden',
        content: 'Når det gamle tag er udtjent, kan en komplet tagudskiftning være den mest økonomiske løsning på lang sigt. Vi har stor erfaring med lægning af alle typer tag, herunder klassiske tegl, betonsten og moderne lette tagløsninger. Vi rådgiver dig grundigt om fordele og ulemper ved de forskellige materialer, så du får et tag, der passer perfekt til dit hus\' arkitektur og dit budget.'
      },
      {
        title: 'Tagrenovering og reparation',
        content: 'Det er ikke altid nødvendigt at skifte hele taget. Ofte kan en grundig tagrenovering, udskiftning af enkelte tagsten, reparation af inddækninger eller renovering af tagudhæng forlænge tagets levetid med mange år. Vi foretager en grundig gennemgang af dit tag og giver en ærlig vurdering af, hvad der bedst kan betale sig.'
      },
      {
        title: 'Materialevalg og rådgivning',
        content: 'Vi samarbejder med anerkendte producenter for at sikre, at dit nye tag lægges med materialer i højeste kvalitet. Uanset om du ønsker et klassisk rødt tegltag, et stilrent sort betontag eller en vedligeholdelsesnem løsning, står vi klar med professionel rådgivning. Vi sørger også for korrekt efterisolering, så du kan reducere din varmeregning og forbedre indeklimaet.'
      }
    ],
    faq: [
      {
        q: 'Hvor meget koster et nyt tag?',
        a: 'Prisen på et nyt tag afhænger af mange faktorer, herunder tagets areal, hældning, valg af tagmateriale (f.eks. tegl, beton eller eternit) samt om der skal udføres efterisolering eller udskiftes spær. Kontakt os for en besigtigelse, så udarbejder vi et skræddersyet og uforpligtende tilbud.'
      },
      {
        q: 'Hvor lang tid tager det at lægge et nyt tag?',
        a: 'Et typisk parcelhustag tager mellem 2 og 4 uger at udskifte, afhængigt af vejrforholdene og projektets omfang. Vi planlægger arbejdet nøje for at minimere generne for dig undervejs.'
      },
      {
        q: 'Kan man lægge nyt tag ovenpå det gamle?',
        a: 'I nogle tilfælde kan man lægge et nyt tag (f.eks. ståltag) ovenpå et eksisterende eternittag, men vi anbefaler som regel at fjerne det gamle tag for at kunne inspicere tagkonstruktionen og spærene for eventuelle skjulte fugtskader.'
      },
      {
        q: 'Er efterisolering lovpligtigt ved tagudskiftning?',
        a: 'Ja, ifølge bygningsreglementet skal der efterisoleres op til gældende krav, hvis det er rentabelt i forbindelse med en større renovering som f.eks. en tagudskiftning. Vi hjælper dig med at beregne dette.'
      }
    ]
  },
  'terrasser': {
    title: 'Eksklusive Træterrasser',
    metaTitle: 'Eksklusive Træterrasser i Egtved',
    metaDesc: 'Drømmer du om en ny træterrasse eller kompositterrasse? Tømrermester Mikkel Juler ApS designer og bygger skræddersyede terrasser i Egtved, Vejle og Kolding.',
    h1: 'Skræddersyede træterrasser & kompositterrasser',
    intro: 'En smuk terrasse forlænger boligen og skaber det perfekte uderum til de lune sommeraftener. Vi designer og bygger eksklusive træterrasser og kompositterrasser tilpasset dine ønsker og havens naturlige terræn.',
    sections: [
      {
        title: 'Træterrasser i eksklusive materialer',
        content: 'Vi bygger terrasser i mange forskellige træsorter, lige fra den klassiske og budgetvenlige trykimprægnerede fyr til eksklusive sorter som sibirisk lærk, ipé, cumaru og teak. Hver træsort har sit eget unikke udtryk og levetid. Vi rådgiver dig om fordele, vedligeholdelse og holdbarhed, så du får en træterrasse, du kan glæde dig over i mange år.'
      },
      {
        title: 'Kompositterrasser – Minimal vedligeholdelse',
        content: 'Ønsker du en terrasse, der kræver minimal vedligeholdelse, og som ikke skal slibes eller olieres hvert år? Så er en kompositterrasse det ideelle valg. Moderne kompositbrædder er yderst slidstærke, splintfrie og modstandsdygtige over for det danske vejr. Vi monterer kompositterrasser med skjulte clips for et rent og skruefrit udtryk.'
      },
      {
        title: 'Specialløsninger og design efter dine ønsker',
        content: 'Ingen haver er ens, og derfor er vores terrasser altid skræddersyede. Vi bygger hævede terrasser, terrasser i flere niveauer, integrerede trapper, rækværk, læhegn og indbyggede plantekasser. Vi tager højde for solforhold, adgangsveje og havens form, så terrassen bliver en naturlig forlængelse af dit hjem.'
      }
    ],
    faq: [
      {
        q: 'Hvilken træsort er bedst til en terrasse?',
        a: 'Det afhænger af dit budget og dine krav til vedligeholdelse. Sibirisk lærk er populært for sit naturlige udseende og gode holdbarhed, mens hårdttræsorter som ipé og cumaru har en ekstremt lang levetid og et eksklusivt udtryk, men ligger i en højere prisklasse.'
      },
      {
        q: 'Hvordan vedligeholder jeg min træterrasse?',
        a: 'En træterrasse bør rengøres for alger og snavs mindst én gang om året. Afhængigt af træsorten kan den behandles med en god terrasseolie for at bevare farven, eller lades ubehandlet, hvis du ønsker, at den med tiden patinerer til en flot sølvgrå nuance.'
      },
      {
        q: 'Hvad er fordelen ved komposit frem for rigtigt træ?',
        a: 'Komposit kræver ingen slibning eller oliering – kun almindelig rengøring med vand og sæbe. Det splintrer ikke, så det er behageligt at gå på med bare tæer, og det holder farven bedre over tid end ubehandlet træ.'
      }
    ]
  },
  'tilbygninger-renovering': {
    title: 'Tilbygninger & Renovering',
    metaTitle: 'Tilbygninger & Renovering i Egtved',
    metaDesc: 'Få mere plads med en tilbygning eller totalrenovering af din bolig. Tømrermester Mikkel Juler ApS står for professionel modernisering og energiforbedring i Egtved.',
    h1: 'Tilbygninger, ombygninger & totalrenovering',
    intro: 'Trænger huset til mere plads, eller drømmer du om at modernisere din bolig? Tømrermester Mikkel Juler ApS har stor erfaring med tilbygninger, ombygninger og totalrenoveringer, der øger boligens værdi og forbedrer din dagligdag.',
    sections: [
      {
        title: 'Flotte tilbygninger i harmoni med dit hus',
        content: 'En tilbygning er en fantastisk måde at få flere kvadratmeter på uden at skulle flytte fra jeres vante rammer. Vi opfører tilbygninger i tæt samarbejde med arkitekter og ingeniører for at sikre, at den nye del falder naturligt ind i husets eksisterende arkitektur. Uanset om du drømmer om et nyt stort køkken-alrum, ekstra børneværelser eller et lyst kontor, fører vi dine planer sikkert ud i livet.'
      },
      {
        title: 'Totalrenovering og modernisering',
        content: 'Har du købt et ældre hus, der trænger til en kærlig hånd, eller ønsker du at opdatere din nuværende bolig? Vi udfører alt inden for renovering, herunder udskiftning af lofter (f.eks. gips eller Troldtekt), lægning af nye trægulve, etablering af skillevægge og modernisering af køkkener. Vi koordinerer gerne med andre faggrupper, så du oplever en glidende og effektiv proces.'
      },
      {
        title: 'Energiforbedringer og isolering',
        content: 'Mange ældre boliger lider under dårlig isolering, hvilket resulterer i høje varmeregninger og et dårligt indeklima. I forbindelse med renovering eller tilbygning tilbyder vi professionel efterisolering af lofter, vægge og gulve. Det er en investering, der hurtigt tjener sig hjem i form af lavere energiudgifter og markant øget boligkomfort.'
      }
    ],
    faq: [
      {
        q: 'Kræver en tilbygning byggetilladelse?',
        a: 'Ja, alle tilbygninger og udvidelser af det samlede boligareal kræver en byggetilladelse fra kommunen, før arbejdet må påbegyndes. Vi rådgiver dig gerne om processen og hjælper med at fremskaffe den nødvendige dokumentation.'
      },
      {
        q: 'Kan vi bo i huset under en totalrenovering?',
        a: 'Det afhænger af renoveringens omfang. Ved mindre renoveringer eller tilbygninger kan man sagtens bo i huset. Ved omfattende totalrenoveringer, hvor f.eks. gulve brydes op eller taget udskiftes, kan det dog være mest praktisk at genhuse sig midlertidigt.'
      },
      {
        q: 'Hvad koster en tilbygning pr. kvadratmeter?',
        a: 'En typisk tilbygning koster mellem 18.000 og 25.000 kr. pr. kvadratmeter, afhængigt af materialevalg, jordbundsforhold, antallet af vinduer og om der skal etableres vådrum (badeværelse/køkken). Vi udarbejder altid et præcist tilbud baseret på dine tegninger.'
      }
    ]
  },
  'doere-vinduer': {
    title: 'Døre & Vinduer',
    metaTitle: 'Døre & Vinduer i Egtved',
    metaDesc: 'Udskiftning af døre og vinduer i Egtved og omegn. Tømrermester Mikkel Juler ApS monterer energirigtige træ/alu-løsninger fra førende danske producenter.',
    h1: 'Udskiftning og montering af døre & vinduer',
    intro: 'Nye døre og vinduer kan forvandle dit hus\' udseende, forbedre indeklimaet og reducere dit varmeforbrug markant. Vi tilbyder professionel udskiftning og montering af energirigtige døre og vinduer i højeste kvalitet.',
    sections: [
      {
        title: 'Energirigtige løsninger, der kan mærkes på varmeregningen',
        content: 'Gamle, utætte vinduer er en af de største kilder til varmetab i boligen. Ved at udskifte til moderne lavenergivinduer med 3-lags glas kan du holde på varmen og reducere dit CO2-aftryk. Vi monterer udelukkende godkendte energivinduer fra førende danske producenter som f.eks. Rationel, Velfac og Outline, hvilket garanterer dig optimal isoleringsevne og lang holdbarhed.'
      },
      {
        title: 'Kvalitetsmaterialer og professionel montering',
        content: 'Valget af materialer er vigtigt. Træ/alu-vinduer er i dag det mest populære valg, da de kombinerer træets varme og naturlige udtryk indvendigt med en vejrbestandig og vedligeholdelsesfri aluminiumsprofil udvendigt. Vi tilbyder også klassiske trævinduer til ældre eller bevaringsværdige ejendomme. Vores montering udføres med stor præcision, korrekt isolering og pæne fuger.'
      },
      {
        title: 'Sikkerhed og komfort i hverdagen',
        content: 'Moderne døre og vinduer er udstyret med effektive indbrudssikringer, der gør det markant sværere for ubudne gæster at trænge ind. Derudover yder de en fantastisk lydisolering, hvilket skaber mere ro og komfort i din bolig, hvis du bor tæt på en trafikeret vej.'
      }
    ],
    faq: [
      {
        q: 'Hvad er fordelen ved træ/alu frem for rent træ?',
        a: 'Træ/alu-vinduer har en udvendig aluminiumsbeklædning, der beskytter træet mod vind og vejr. Det betyder, at de aldrig skal males udvendigt, men blot skal vaskes af med vand og sæbe et par gange om året. Indvendigt har de stadig det hyggelige træ-look.'
      },
      {
        q: 'Hvor meget kan jeg spare ved at skifte vinduer?',
        a: 'Besparelsen afhænger af dine nuværende vinduers stand. Hvis du skifter fra gamle 1-lags eller slidte 2-lags termoruder til nye 3-lags energivinduer, kan en gennemsnitlig husstand typisk spare flere tusinde kroner årligt på varmeregningen.'
      },
      {
        q: 'Hvor lang tid tager det at udskifte vinduer i et helt hus?',
        a: 'I et almindeligt parcelhus tager det typisk mellem 2 og 4 arbejdsdage at udskifte alle døre og vinduer. Vi sørger for at udskifte dem løbende, så huset aldrig står helt åbent natten over.'
      }
    ]
  }
};

export default function YdelseDetail() {
  const { slug } = useParams();
  const data = ydelserData[slug];
  
  const [galleryImages, setGalleryImages] = useState([]);
  const [activeFaq, setActiveFaq] = useState(null);
  const [lightboxIndex, setLightboxIndex] = useState(null);
  const [loading, setLoading] = useState(true);

  // Map URL slug til CMS slug_ref
  const cmsSlugRef = slug === 'tilbygninger-renovering' ? 'tilbygninger' : slug;

  useEffect(() => {
    async function fetchGallery() {
      setLoading(true);
      try {
        const res = await fetch(`https://api.dev.auxo.dk/public/v2/content/gallery?slug_ref=${cmsSlugRef}`);
        if (res.ok) {
          const result = await res.json();
          // Find det matchende galleri i items
          const matchedGallery = result.items?.find(item => item.slug_ref === cmsSlugRef);
          if (matchedGallery && matchedGallery.images) {
            setGalleryImages(matchedGallery.images);
          } else {
            setGalleryImages([]);
          }
        }
      } catch (error) {
        console.error("Fejl ved hentning af galleri:", error);
      } finally {
        setLoading(false);
      }
    }

    if (cmsSlugRef) {
      fetchGallery();
    }
  }, [cmsSlugRef]);

  if (!data) {
    return (
      <div className="max-w-7xl mx-auto px-4 py-20 text-center">
        <h1 className="text-3xl font-bold text-brand-dark mb-4">Ydelsen blev ikke fundet</h1>
        <p className="text-brand-dark-light mb-8">Vi kunne desværre ikke finde den ydelse, du leder efter.</p>
        <Link to="/" className="bg-brand-green text-white px-6 py-3 rounded-xl font-semibold">
          Gå til forsiden
        </Link>
      </div>
    );
  }

  const toggleFaq = (index) => {
    setActiveFaq(activeFaq === index ? null : index);
  };

  return (
    <>
      <SEO title={data.metaTitle} description={data.metaDesc} />

      {/* Hero / Header */}
      <section className="bg-brand-wood-light py-12 md:py-16 border-b border-gray-100">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl">
            <nav className="flex mb-4 text-xs sm:text-sm text-gray-500 gap-2 items-center">
              <Link to="/" className="hover:text-brand-wood">Forside</Link>
              <i className="fa-solid fa-chevron-right text-[10px]" />
              <span className="text-brand-dark font-medium">Ydelser</span>
              <i className="fa-solid fa-chevron-right text-[10px]" />
              <span className="text-brand-wood-dark font-semibold">{data.title}</span>
            </nav>
            <h1 className="text-3xl sm:text-4xl md:text-5xl font-bold text-brand-dark tracking-tight leading-tight">
              {data.h1}
            </h1>
            <p className="mt-4 text-base sm:text-lg text-brand-dark-light leading-relaxed">
              {data.intro}
            </p>
          </div>
        </div>
      </section>

      {/* Indhold & Galleri */}
      <section className="bg-white py-16 md:py-24">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12">
            {/* Tekstsektioner */}
            <div className="lg:col-span-7 space-y-12">
              {data.sections.map((sec, idx) => (
                <div key={idx} className="space-y-4">
                  <h2 className="text-2xl font-bold text-brand-dark flex items-center gap-3">
                    <span className="w-1.5 h-6 bg-brand-wood rounded-full block" />
                    {sec.title}
                  </h2>
                  <p className="text-brand-dark-light leading-relaxed text-base sm:text-lg">
                    {sec.content}
                  </p>
                </div>
              ))}

              {/* FAQ Harmonika */}
              <div className="pt-8 border-t border-gray-100 space-y-6">
                <h2 className="text-2xl font-bold text-brand-dark">Ofte stillede spørgsmål (FAQ)</h2>
                <div className="space-y-4">
                  {data.faq.map((item, idx) => (
                    <div 
                      key={idx} 
                      className="border border-gray-100 rounded-2xl bg-brand-cream overflow-hidden transition-all duration-200"
                    >
                      <button
                        onClick={() => toggleFaq(idx)}
                        className="w-full text-left px-6 py-4 font-bold text-brand-dark flex justify-between items-center hover:text-brand-wood cursor-pointer focus:outline-none"
                      >
                        <span>{item.q}</span>
                        <i className={`fa-solid fa-chevron-down text-xs transition-transform duration-200 ${activeFaq === idx ? 'rotate-180 text-brand-wood' : 'text-gray-400'}`} />
                      </button>
                      {activeFaq === idx && (
                        <div className="px-6 pb-5 pt-1 text-brand-dark-light text-sm sm:text-base leading-relaxed border-t border-gray-50 bg-white">
                          {item.a}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              </div>
            </div>

            {/* Galleri & Sidebar */}
            <div className="lg:col-span-5 space-y-8">
              {/* Galleri */}
              <div className="bg-brand-cream p-6 sm:p-8 rounded-2xl border border-gray-100">
                <h3 className="text-lg font-bold text-brand-dark mb-4 flex items-center gap-2">
                  <i className="fa-solid fa-images text-brand-wood" />
                  <span>Galleri: {data.title}</span>
                </h3>
                
                {loading ? (
                  <div className="flex justify-center py-8">
                    <div className="w-8 h-8 border-3 border-brand-green border-t-transparent rounded-full animate-spin" />
                  </div>
                ) : galleryImages.length > 0 ? (
                  <div className="grid grid-cols-2 gap-4">
                    {galleryImages.map((imgUrl, idx) => (
                      <div 
                        key={idx}
                        onClick={() => setLightboxIndex(idx)}
                        className="group relative h-28 sm:h-36 rounded-xl overflow-hidden cursor-pointer shadow-xs hover:shadow-md transition-all duration-200"
                      >
                        <img 
                          src={imageUrl(imgUrl, 'width=400,height=300,fit=cover,quality=80,format=auto')} 
                          alt={`${data.title} projektbillede ${idx + 1}`}
                          className="w-full h-full object-cover transition-transform duration-300 group-hover:scale-105"
                        />
                        <div className="absolute inset-0 bg-black/20 opacity-0 group-hover:opacity-100 transition-opacity duration-200 flex items-center justify-center">
                          <i className="fa-solid fa-magnifying-glass-plus text-white text-lg" />
                        </div>
                      </div>
                    ))}
                  </div>
                ) : (
                  <p className="text-sm text-gray-400 italic">Der er i øjeblikket ingen billeder i dette galleri.</p>
                )}
                
                <p className="text-xs text-gray-400 mt-4 text-center">
                  <i className="fa-solid fa-circle-info mr-1" />
                  Klik på et billede for at se det i fuld størrelse.
                </p>
              </div>

              {/* Kontakt-CTA Sidebar */}
              <div className="bg-brand-dark text-white p-6 sm:p-8 rounded-2xl border border-gray-800 relative overflow-hidden">
                <div className="absolute -right-10 -bottom-10 w-40 h-40 rounded-full bg-brand-wood/10 pointer-events-none" />
                <h3 className="text-xl font-bold mb-3">Skal vi hjælpe dig?</h3>
                <p className="text-gray-300 text-sm leading-relaxed mb-6">
                  Få en uforpligtende snak om dine muligheder og et skræddersyet tilbud på {data.title.toLowerCase()}. Vi rådgiver dig hele vejen.
                </p>
                <div className="space-y-4">
                  <Link 
                    to="/kontakt" 
                    className="block w-full text-center bg-brand-green hover:bg-brand-green/90 text-white font-semibold py-3 rounded-xl transition-colors text-sm cursor-pointer"
                  >
                    Få et uforpligtende tilbud
                  </Link>
                  <a 
                    href="tel:+4528455012" 
                    className="block w-full text-center bg-brand-dark-light hover:bg-brand-dark-light/80 border border-gray-700 text-white font-semibold py-3 rounded-xl transition-colors text-sm"
                  >
                    <i className="fa-solid fa-phone text-brand-wood mr-2" />
                    Ring: 28 45 50 12
                  </a>
                </div>
              </div>

              {/* Interne links til andre ydelser */}
              <div className="bg-white p-6 sm:p-8 rounded-2xl border border-gray-100">
                <h3 className="text-lg font-bold text-brand-dark mb-4">Andre ydelser</h3>
                <ul className="space-y-3 text-sm">
                  {Object.keys(ydelserData).filter(k => k !== slug).map(key => (
                    <li key={key}>
                      <Link 
                        to={`/ydelser/${key}`} 
                        className="text-brand-dark-light hover:text-brand-wood transition-colors flex items-center gap-2 font-medium"
                      >
                        <i className="fa-solid fa-chevron-right text-xs text-brand-wood" />
                        <span>{ydelserData[key].title}</span>
                      </Link>
                    </li>
                  ))}
                </ul>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Lightbox */}
      {lightboxIndex !== null && (
        <Lightbox 
          images={galleryImages}
          currentIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
          onPrev={() => setLightboxIndex((lightboxIndex - 1 + galleryImages.length) % galleryImages.length)}
          onNext={() => setLightboxIndex((lightboxIndex + 1) % galleryImages.length)}
        />
      )}
    </>
  );
}
